import { NavSection } from "src/components/layout/nav/nav-section";

import { Icon } from "src/components/layout/nav/icons/integrations";
import type { ActiveSectionProps } from "src/components/layout/nav/utils";
import type { UseSectionHook } from "./types";
import { isPresent } from "ts-extras";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useUser } from "src/contexts/user-context";

export const useIntegrationsSection: UseSectionHook = () => {
  const { appAlertingV2Eligible, appEnableGartnerDemo } = useFlags();
  const { workspace } = useUser();

  return {
    title: "Integrations",
    isEnabled: true,
    links: [
      {
        href: "/destinations",
        label: "Destinations",
      },
      {
        href: "/sources",
        label: "Sources",
      },
      {
        href: "/extensions",
        label: "Extensions",
      },
      appAlertingV2Eligible || workspace?.alerting_v2_enabled
        ? {
            href: "/alerting",
            label: "Alerting",
          }
        : null,
      appEnableGartnerDemo && {
        href: "/connections",
        label: "Connections",
        permissions: { v2: { resource: "workspace", grant: "can_read" } },
      },
    ].filter(isPresent),
  };
};

export const Integrations = (props: ActiveSectionProps) => {
  const section = useIntegrationsSection();
  return <NavSection icon={Icon} {...section} {...props} />;
};
